/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition'
import { cx } from '@emotion/css'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import colors from '../../themes/colors'
import AccessibleIcon from '../AccessibleIcon'
import styles, { wrapperTop, wrapperTransition } from './styles'

class SystemError extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    dismissTimeout: null,
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      // If the error becomes visible, start a timeout to auto-hide it
      clearInterval(this.state.dismissTimeout)
      const dismissTimeout = setTimeout(this.autoHide, this.props.hideTimeout)
      this.setState({ dismissTimeout })
    }
  }

  autoHide = () => {
    // If the notification is still visible when the timeout is due, hide it
    if (this.props.visible) {
      this.props.hide()
      // Clear the message after 300ms (transition time)
      setTimeout(this.props.clear, 300)
    }
  }

  render() {
    const { visible, offsetTop, className, message, hide } = this.props

    return (
      <Transition in={visible} timeout={300} mountOnEnter unmountOnExit>
        {status => (
          <div className={cx(styles.wrapper, className, wrapperTop(offsetTop), wrapperTransition(status))}>
            <div className={styles.container}>
              {message}
              <span className={styles.icon} onClick={hide}>
                <AccessibleIcon icon={CloseIcon} color={colors.mandy} size={18} />
              </span>
            </div>
          </div>
        )}
      </Transition>
    )
  }
}

SystemError.propTypes = {
  offsetTop: PropTypes.number,
  visible: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  hide: PropTypes.func,
  clear: PropTypes.func,
  hideTimeout: PropTypes.number,
}

SystemError.defaultProps = {
  hideTimeout: 10000,
}

export default SystemError
